export default __webpack_public_path__ + "static/media/lm.001.1c0510df.png";